/**
 * Configuration shapes for `@infocert/onboarding-widget`. Frontend-only widget config, not part
 * of any backend contract — previously modeled as orphan OpenAPI schemas (never referenced by any
 * operation) purely to get generated TS interfaces; hand-maintained here instead.
 */

export interface OnboardingWidgetColorsConfigPrimary {
  /** Main primary color (hex) */
  main?: string;
  /** Dark variant of primary color (hex) */
  dark?: string;
}

export interface OnboardingWidgetColorsConfigSecondary {
  /** Main secondary color (hex) */
  main?: string;
}

/** Color configuration for the widget theme */
export interface OnboardingWidgetColorsConfig {
  primary?: OnboardingWidgetColorsConfigPrimary;
  secondary?: OnboardingWidgetColorsConfigSecondary;
}

/** Button styling configuration */
export interface OnboardingWidgetButtonConfig {
  /** Border radius for buttons (e.g., "4px", "8px") */
  borderRadius?: string;
}

/** Theme settings for the widget */
export interface OnboardingWidgetThemeConfig {
  /** Font family to use */
  fontFamily?: string;
  /** Background color of the widget surface (CSS color value) */
  background?: string;
  colors?: OnboardingWidgetColorsConfig;
}

/** Customization options for the onboarding widget appearance */
export interface OnboardingWidgetCustomization {
  theme?: OnboardingWidgetThemeConfig;
  button?: OnboardingWidgetButtonConfig;
}

/** Environment where the widget operates */
export type OnboardingWidgetEnvironment = 'test' | 'staging' | 'preprod' | 'production';

export const OnboardingWidgetEnvironment = {
  Test: 'test' as OnboardingWidgetEnvironment,
  Staging: 'staging' as OnboardingWidgetEnvironment,
  Preprod: 'preprod' as OnboardingWidgetEnvironment,
  Production: 'production' as OnboardingWidgetEnvironment,
};

/** Properties for configuring the onboarding widget */
export interface OnboardingWidgetProperties {
  /** Authentication token for the widget */
  auth_token?: string;
  customization?: OnboardingWidgetCustomization;
  env?: OnboardingWidgetEnvironment;
  /** Language code for the widget (e.g., it-IT, en-US) */
  language?: string;
  /** Base path for widget assets */
  widget_base_path?: string | null;
}
